var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fade-transition',[(_vm.isLoading)?_c('div',{class:_vm.b()},[_c('half-circle-spinner',{class:_vm.b('spinner'),attrs:{"size":_vm.spinner.size,"color":_vm.spinner.color,"animation-duration":_vm.spinner.animDuration}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }